
const NO_TRANSLATE = '###_NO_TRANSLATE_###';

const TIMEZONE_UTC = 'UTC';

const GLOBAL_POSTPROCESSOR = '*' as const;

const MS_IN_MINUTE = 1000 * 60;
const MS_IN_HOUR = MS_IN_MINUTE * 60;
const MS_IN_DAY = MS_IN_HOUR * 24;
// согласовано с Р. Тютюником, что недели не используем в акциях - не информативно
// const MS_IN_WEEK = MS_IN_DAY * 7;
const MS_IN_MONTH = MS_IN_DAY * 30;


export {
    NO_TRANSLATE,
    TIMEZONE_UTC,
    GLOBAL_POSTPROCESSOR,
    MS_IN_MINUTE,
    MS_IN_HOUR,
    MS_IN_DAY,
    MS_IN_MONTH,
}
